<template>
  <div>
    <a-card
      :bordered="false"
      :title="id?'编辑商品':'新增商品'"
    >
      <a-button
        slot="extra"
        @click="handleCancel"
        class="mr-10"
      >
        取消
      </a-button>
      <a-button
        slot="extra"
        type="primary"
        :loading="confirmLoading"
        @click="handleSave"
      >
        保存
      </a-button>
      <div style="overflow: auto">
        <div class="box">
          <a-form-model
            ref="form"
            :model="formData"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            class="box-left"
          >
            <div class="form-title">基本信息</div>
            <a-form-model-item
              v-if="id"
              label="页面链接"
            >
              {{ formData.goods_url }}
            </a-form-model-item>
            <a-form-model-item
              label="商品标题"
              prop="name"
            >
              <a-input v-model="formData.name" allowClear/>
            </a-form-model-item>
            <a-form-model-item
              label="副标题"
              prop="desc"
            >
              <a-input v-model="formData.desc" allowClear/>
            </a-form-model-item>
            <a-form-model-item
              label="商品图片"
              prop="picture"
            >
              <div>图片建议750 * 750</div>
              <up-load-mult v-model="formData.picture" />
            </a-form-model-item>
            <!--导航start-->
            <div class="form-title">导航栏
              <a-button
                v-if="formData.navigation.length<10"
                type="primary"
                size="small"
                class="ml-10"
                @click="handleAddNav"
              >
                添加导航
              </a-button>
            </div>
            <div class="form-sub-title">最多添加10个导航，最多排列两行，每行最多5个</div>
            <a-empty v-if="!formData.navigation.length">
              <span slot="description">还未添加导航</span>
            </a-empty>
            <template v-if="formData.navigation.length">
              <a-card v-for="(item, index) in formData.navigation" :title="`${index+1}、${item.title || '导航'}`" :key="`${index+20}`" size="small" class="mt-10">
                <a-icon
                  slot="extra"
                  type="delete"
                  @click="handleDeleteNav($event, item, index)"
                />
                <div class="flex-box">
                  <a-form-model-item
                    :prop="'navigation.' + index + '.icon'"
                    :rules="{ required: true, message: '图片必填', trigger: 'change'}"
                  >
                    <up-load v-model="item.icon" />
                  </a-form-model-item>
                  <div class="flex-box-grow-1">
                    <a-form-model-item
                      label="导航序号"
                      :label-col="{ span: 6 }"
                      :wrapper-col="{ span: 16 }"
                      :prop="'navigation.' + index + '.sort'"
                      :rules="{ required: true, message: '展示顺序必填', trigger: 'blur'}"
                    >
                      <a-input-number
                        v-model="item.sort"
                        placeholder="填写展示顺序"
                      />
                    </a-form-model-item>
                    <a-form-model-item
                      label="导航文本"
                      :label-col="{ span: 6 }"
                      :wrapper-col="{ span: 16 }"
                      :prop="'navigation.' + index + '.title'"
                      :rules="{ required: true, message: '导航文本必填', trigger: 'blur'}"
                    >
                      <a-input
                        v-model="item.title"
                        :maxLength="6"
                        placeholder="不超过6个字"
                        allowClear
                      />
                    </a-form-model-item>
                    <a-form-model-item
                      label="跳转页面"
                      :label-col="{ span: 6 }"
                      :wrapper-col="{ span: 16 }"
                      :prop="'navigation.' + index + '.url'"
                      :rules="{ required: true, message: '说明书', trigger: 'blur'}"
                    >
                      <div @click="handleSelectLinkNav(item, index)">
                        <a-textarea
                          v-model="item.url"
                          placeholder="点击选择链接"
                        />
                      </div>
                    </a-form-model-item>
                  </div>
                </div>
              </a-card>
            </template>
            <!--导航end-->
            <a-form-model-item label="商品价格" class="mt-20">
              <a-input-number v-model="formData.price" :min="0" /> 元
            </a-form-model-item>
            <a-form-model-item
              label="说明书"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 16 }"
            >
              <div @click="handleSelectLink(details)">
                <a-textarea
                  v-model="formData.instructions_url"
                  placeholder="点击选择链接"
                />
              </div>
            </a-form-model-item>
            <!-- 选择链接 -->
            <Link ref="link" @ok="handleLinkOk" />
            <Link ref="linkC" @ok="handleLinkOkC" />
            <Link ref="linkNav" @ok="handleLinkOkNav" />
            <a-form-model-item label="商品分类" prop="category_ids">
              <a-tree
                v-model="formData.category_ids"
                checkable
                :selectable="false"
                :auto-expand-parent="autoExpandParent"
                :tree-data="treeData"
                :replace-fields="replaceFields"
              />
            </a-form-model-item>
            <a-form-model-item label="商品排序" prop="sort">
              <a-input-number v-model="formData.sort" :min="0" />
            </a-form-model-item>
            <a-form-model-item label="规格属性">
              <a-button
                type="primary"
                size="small"
                class="ml-10"
                @click="handleAddSpec"
              >
                新增
              </a-button>
              <a-row :gutter="10" justify="space-around" v-for="(item, index) in formData.spec" :key="index">
                <a-col :span="10">
                  <a-form-model-item class="mr-10" :prop="'spec.' + index + '.name'" :rules="{ required: true, message: '规格名称必填', trigger: 'blur'}">
                    <a-input v-model="item.name" placeholder="规格名称" allowClear />
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item class="mr-10" :prop="'spec.' + index + '.value'" :rules="{ required: true, message: '规格值必填', trigger: 'blur'}">
                    <a-input v-model="item.value" placeholder="规格值" allowClear />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-button
                    type="danger"
                    size="small"
                    @click="handleDelSpec(index)"
                  >
                    删除
                  </a-button>
                </a-col>
              </a-row>
            </a-form-model-item>
            <a-form-model-item
              label="商品状态"
              required
            >
              <a-radio-group v-model="formData.status">
                <a-radio v-for="item in statusDict" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item
              class="mt-20"
              label="视频展示"
            >
              <div>请上传视频封面 + 视频（建议尺寸750 * 360）
                <a-button
                  type="primary"
                  size="small"
                  class="ml-10"
                  @click="handleAddVideo"
                >
                  添加视频
                </a-button></div>
              <a-card v-for="(item, index) in formData.video" :title="`${item.title || '视频组'}${index+1}`" :key="index" size="small" class="mt-10">
                <a-icon
                  slot="extra"
                  type="delete"
                  @click="handleDeleteVideo($event, item, index)"
                />
                <up-load v-model="formData.video[index].pic_url" />
                <up-load-video v-model="formData.video[index].video_url" />
              </a-card>
            </a-form-model-item>
            <div class="form-title">图片展示
              <a-button
                v-if="formData.content.length<5"
                type="primary"
                size="small"
                class="ml-10"
                @click="handleAddContent"
              >
                添加图片
              </a-button>
            </div>
            <a-empty v-if="!formData.content.length">
              <span slot="description">没有添加图片</span>
            </a-empty>
            <template v-if="formData.content.length">
              <a-card v-for="(item, index) in formData.content" :title="`${index+1}、图片`" :key="`${index+10}`" size="small" class="mt-10">
                <a-icon
                  slot="extra"
                  type="delete"
                  @click="handleDeleteContent($event, item, index)"
                />
                <div class="flex-box">
                  <a-form-model-item
                    class="image-box"
                    :rules="{ required: true, message: '图片必填', trigger: 'change'}"
                    :prop="'content.' + index + '.content_url'"
                  >
                    <up-load v-model="item.content_url" />
                  </a-form-model-item>
                  <div class="flex-box-grow-1">
                    <a-form-model-item
                      label="跳转页面"
                      :label-col="{ span: 6 }"
                      :wrapper-col="{ span: 16 }"
                      :prop="'content.' + index + '.jump_url'"
                    >
                      <div @click="handleSelectLinkC(item, index)">
                        <a-textarea
                          v-model="item.jump_url"
                          placeholder="点击选择链接"
                        />
                      </div>
                    </a-form-model-item>
                  </div>
                </div>
              </a-card>
            </template>
          </a-form-model>
          <!-- 效果预览 -->
          <div v-if="id" class="box-right">
            <div class="form-title">点击保存后，即可浏览页面效果。
              <a-button
                type="primary"
                size="small"
                class="ml-10"
                @click="handleRefreshPreview"
              >
                刷新
              </a-button>
            </div>
            <div class="phone-box">
              <iframe
                name="goodsIframe"
                id="goodsIframe"
                frameborder="0"
                width="100%"
                height="100%"
                :src="formData.goods_url"
                allowFullScreen="true"
              ></iframe>
            </div>
          </div>
        </div>
        <!-- 保修激活时间start -->
        <a-form-model-item label="保修激活倒计时" class="form-title">
          <a-input-group compact>
            <a-input-number :min="0" style="width: 100px" v-model="formData.guarantee_term.preTerm"/>
            <a-select style="width: 60px" v-model="formData.guarantee_term.preUnit">
              <a-select-option value="year">
                年
              </a-select-option>
              <a-select-option value="month">
                月
              </a-select-option>
              <a-select-option value="day">
                日
              </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>
        <!-- 保修激活时间end -->
        <!-- 基础报修start -->
        <a-form-model-item label="基础保修时间" class="form-title" style="margin-top: -4rem">
          <a-input-group compact>
            <a-input-number :min="0" style="width: 100px" v-model="formData.guarantee_term.term"/>
            <a-select style="width: 60px" v-model="formData.guarantee_term.unit">
              <a-select-option value="year">
                年
              </a-select-option>
              <a-select-option value="month">
                月
              </a-select-option>
              <a-select-option value="day">
                日
              </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>
        <div style="margin-top: -30px">说明：保修期内才可以购买延保，保修激活倒计时到期后开始计算保修时间<br/>
          注意：若在倒计时结束前进行登记，保修激活倒计时自动清零，直接开始保修时间</div>
        <!-- 基础保修end -->
      </div>
    </a-card>
  </div>
</template>
<script>
import UpLoad from '@/components/UpLoad'
import UpLoadMult from '@/components/UpLoadMult'
import UpLoadVideo from '@/components/video'
import wangEditor from '@/components/wangEditor'
import Link from '@/components/Link'
import { deepClone, formatPath } from '@/utils'
import { getGoodsPre, postGoodsAdd, postGoodsEdit, getGoodsDetail } from '@/api/goods'
const defaultVideo = {
  video_url: '',
  pic_url: ''
}
const defaultContent = {
  content_url: '',
  jump_url: '',
  goods_id: '',
  page_id: '',
  sort: 0
}
const defaultNav = {
  sort: 0,
  title: '',
  icon: '',
  url: '',
  goods_id: '',
  page_id: ''
}
const defaultFormData = {
  name: '', // 商品名称
  desc: '', // 副标题
  picture: [], // 商品图片 ['http://czdongsheng.oss-cn-shenzhen.aliyuncs.com/ATTRIBUTE/20210224/a2d03eaa4dae9b9af8d54d424e8d022b.jpg', 'http://czdongsheng.oss-cn-shenzhen.aliyuncs.com/ATTRIBUTE/20210224/a2d03eaa4dae9b9af8d54d424e8d022b.jpg']
  price: '', // 商品价格
  category_ids: [], // 商品分类(多个使用英文逗号隔开)
  instructions_url: '', // 详情页链接
  sort: 0, // 商品排序
  spec: [], // 商品规格
  status: 'NORMAL', // 商品状态 NORMAL-正常 FORBIDDEN-下架.
  content: [Object.assign({}, defaultContent)], // 商品详情图片
  video: [Object.assign({}, defaultVideo)], // 视频封面和视频
  navigation: [Object.assign({}, defaultNav)], // 自定义页面导航栏（[{title:'导航名称','icon':'图标地址','sort':'排序','goods_id':'关联商品ID','page_id':'管理页面ID'}]）.
  guarantee_term: { term: 0, unit: 'year', preTerm: 0, preUnit: 'year' }
}
const defaultSpec = { name: '', value: '' }

export default {
  name: 'GoodsForm',
  components: { UpLoadMult, wangEditor, Link, UpLoad, UpLoadVideo },
  data() {
    return {
      status: 'create',
      confirmLoading: false,
      labelCol: { xxl: { span: 3 }, xl: { span: 4 }, lg: { span: 5 }, md: { span: 6 }, sm: { span: 8 }, xs: { span: 8 } },
      wrapperCol: { xxl: { span: 14 }, xl: { span: 16 }, lg: { span: 16 }, md: { span: 16 }, sm: { span: 16 }, xs: { span: 16 } },
      formData: deepClone(defaultFormData),

      rules: {
        name: [{ required: true, message: '商品标题必填', trigger: 'blur' }],
        picture: [{ type: 'array', required: true, message: '商品图片必填', trigger: 'change' }],
        category_ids: [{ type: 'array', required: true, message: '商品分类必填', trigger: 'change' }],
        sort: [{ required: true, message: '商品排序必填', trigger: 'blur' }]
      },
      details: { goods_id: '', url: '', page_id: '' }, // 详情页
      timer: null,
      // 树
      autoExpandParent: true,
      treeData: [], // 商品分类树
      replaceFields: {
        children: 'sub_category_list',
        checkable: 'checkable',
        title: 'name',
        key: 'id',
        disableCheckbox: 'disableCheckbox'
      },
      currentContentUrl: 0,
      currentNavIndex: 0,
      // 状态字典
      statusDict: [{ id: 'NORMAL', name: '正常' }, { id: 'FORBIDDEN', name: '下架' }]
    }
  },
  created() {
    this.id = this.$route.query && this.$route.query.id ? this.$route.query.id : ''
    if (this.id) {
      // 编辑
      this.getDetail()
      this.status = 'edit'
    } else {
      // 新增
      this.status = 'create'
      this.formData = deepClone(defaultFormData)
    }
    this.getPre()
  },
  watch: {
    formData: {
      handler(val) {
        if (this.status === 'edit') {
          // 向IFRAME通信
          this.postMessage()
        }
      },
      deep: true
    },
    '$route': {
      handler(route) {
        if (route.name === 'goodsAdd' || route.name === 'goodsEdit') {
          // 刷新数据
          this.getPre()
        }
      },
      deep: true
    }
  },
  methods: {
    // 向IFRAME通信传值
    postMessage () {
      const iframe = document.getElementById('goodsIframe')
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        iframe.contentWindow.postMessage(this.formData, this.formData.goods_url)
      }, 2000)
    },
    // 添加规格属性
    handleAddSpec() {
      this.formData.spec.push(Object.assign({}, defaultSpec))
    },
    // 删除规格属性
    handleDelSpec(index) {
      this.$confirm({
        title: '确定要删除该规格属性?',
        onOk: () => {
          this.formData.spec.splice(index, 1)
        }
      })
    },
    // 保存
    handleSave() {
      // 封面存在时， 必须上传视频，视频存在但没有上传封面时用视频的首贞做封面
      var video = this.formData.video
      for (var i = 0; i < video.length; i++) {
        if (!video[i].video_url) {
          // 没有视频时删除组件
          video.splice(i, 1)
          i--
          continue
        }
        if (!video[i].pic_url && video[i].video_url) {
          this.formData.video[i].pic_url = video[i].video_url + '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto'
        }
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.id) {
            // 编辑
            this.postEdit()
          } else {
            // 新增
            this.postAdd()
          }
        } else {
          this.$message.error('还有字段未填写，请检查！')
          return false
        }
      })
    },
    // 点击 取消 按钮
    handleCancel() {
      this.$router.go(-1)
    },
    // 刷新页面效果
    handleRefreshPreview() {
      // 跨域问题
      // document.getElementById('goodsIframe').contentWindow.location.reload(true)
      document.getElementById('goodsIframe').src = this.formData.goods_url
      // 向IFRAME通信
      this.postMessage()
    },
    // 预加载
    getPre() {
      getGoodsPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            for (var i = 0; i < data.categoryList.length; i++) {
              data.categoryList[i].disableCheckbox = true
              data.categoryList[i].checkable = false
            }
            this.treeData = data.categoryList
            this.statusDict = data.statusDict
            // 没有商品分类的时候 直接先提示“您还没有商品分类 请先新增分类”然后确定跳转商品分类管理页面
            if (!data.categoryList.length) {
              this.$message.warning('您还没有商品分类 请先新增分类', 3)
              this.timer = setTimeout(() => {
                this.toGoodsTypeList()
                this.timer = null
              }, 2000)
            } else {
              var li = data.categoryList
              for (var j = 0; j < li.length; j++) {
                if (li[j].sub_category_list.length > 0) {
                  // this.cateCheck()
                  // 存在二级分类则不再跳转
                  return false
                }
                if (li.length - 1 === j) {
                  this.$message.warning('您还没有商品二级分类 请先新增分类', 3)
                  this.timer = setTimeout(() => {
                    this.toGoodsTypeList()
                    this.timer = null
                  }, 2000)
                }
              }
            }
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载接口失败')
        })
    },
    // 跳转到商品分类管理
    toGoodsTypeList() {
      // 打印订单关闭则跳转到订单详情页，避免重复提交订单
      this.$router.push({ name: 'goodsTypeList' })
    },
    // 转换成接口所需参数
    paramsFormat() {
      const categoryIds = this.formData.category_ids.join(',')
      const picture = this.formData.picture.map(formatPath)
      const content = deepClone(this.formData.content)
      const video = deepClone(this.formData.video)
      const navigation = deepClone(this.formData.navigation)
      const guarantee = deepClone(this.formData.guarantee_term)
      video.map((item, index) => {
        video[index].video_url = formatPath(item.video_url)
        video[index].pic_url = formatPath(item.pic_url)
      })
      content.map((item, index) => {
        content[index].content_url = formatPath(item.content_url)
      })
      navigation.map((item, index) => {
        navigation[index].icon = formatPath(item.icon)
      })
      return Object.assign({}, this.formData, { category_ids: categoryIds, picture, video, content, navigation, guarantee })
    },
    // 编辑
    postEdit() {
      this.confirmLoading = true
      postGoodsEdit(this.paramsFormat())
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            // this.handleCancel()
            this.getDetail()
            this.handleRefreshPreview()
          }
        })
        .catch((e) => {
          this.$message.error('保存失败')
        })
        .finally(() => { this.confirmLoading = false })
    },
    // 新增
    postAdd() {
      this.confirmLoading = true
      postGoodsAdd(this.paramsFormat())
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.$store.dispatch('removeTab', this.$route.fullPath)
            this.handleCancel()
          }
        })
        .catch((e) => {
          this.$message.error('保存失败')
        })
        .finally(() => { this.confirmLoading = false })
    },
    // 详情
    getDetail() {
      getGoodsDetail({
        goods_id: this.id
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.formData = {
              goods_url: data.goods_url,
              instructions_url: data.instructions_url,
              goods_id: data.goods_id,
              video: data.video,
              content: data.content,
              name: data.name,
              desc: data.desc,
              category_ids: data.category_ids ? data.category_ids.split(',').map(Number) : [],
              picture: data.picture,
              price: data.price,
              spec: data.spec,
              sort: data.sort,
              status: data.status,
              navigation: data.navigation,
              guarantee_term: data.guarantee_term
            }
          }
        })
        .catch((e) => {
          this.$message.error('获取详情接口失败')
        })
    },
    // 添加视频组件
    handleAddVideo() {
      this.formData.video.push(Object.assign({}, defaultVideo))
    },
    // 删除视频组件
    handleDeleteVideo(event, item, index) {
      event.stopPropagation()
      this.$confirm({
        title: '确定要删除该组件?',
        onOk: () => {
          this.formData.video.splice(index, 1)
        }
      })
    },
    // 点击选择说明书连接
    handleSelectLink(item) {
      this.$refs.link.showModal({
        id: item.goods_id || item.page_id,
        url: item.url,
        type: item.goods_id ? 'GOODS' : 'PAGE'
      })
    },
    // 确定选择说明书链接
    handleLinkOk(selected) {
      this.details.goods_id = (selected.type === 'GOODS') ? selected.id : 0
      this.details.page_id = (selected.type === 'PAGE') ? selected.id : 0
      this.details.url = selected.url
      this.formData.instructions_url = selected.url
    },
    // 添加图片展示
    handleAddContent() {
      this.formData.content.push(Object.assign({}, defaultContent))
    },
    // 删除图片展示
    handleDeleteContent(event, item, index) {
      event.stopPropagation()
      this.$confirm({
        title: '确定要删除该组件?',
        onOk: () => {
          this.formData.content.splice(index, 1)
        }
      })
    },
    // 图片展示点击选择链接
    handleSelectLinkC(item, index) {
      this.currentContentUrl = index
      this.$refs.linkC.showModal({
        id: item.goods_id || item.page_id,
        url: item.url,
        type: item.goods_id ? 'GOODS' : 'PAGE'
      })
    },
    // 图片展示确定选择链接
    handleLinkOkC(selected) {
      this.formData.content[this.currentContentUrl].goods_id = (selected.type === 'GOODS') ? selected.id : 0
      this.formData.content[this.currentContentUrl].page_id = (selected.type === 'PAGE') ? selected.id : 0
      this.formData.content[this.currentContentUrl].jump_url = selected.url
    },
    // 添加导航
    handleAddNav() {
      this.formData.navigation.push(Object.assign({}, defaultNav))
    },
    // 删除导航
    handleDeleteNav(event, item, index) {
      event.stopPropagation()
      this.$confirm({
        title: '确定要删除该组件?',
        onOk: () => {
          this.formData.navigation.splice(index, 1)
        }
      })
    },
    // 导航点击选择链接
    handleSelectLinkNav(item, index) {
      this.currentNavIndex = index
      this.$refs.linkNav.showModal({
        id: item.goods_id || item.page_id,
        url: item.url,
        type: item.goods_id ? 'GOODS' : 'PAGE'
      })
    },
    // 导航确定选择链接
    handleLinkOkNav(selected) {
      this.formData.navigation[this.currentNavIndex].goods_id = (selected.type === 'GOODS') ? selected.id : 0
      this.formData.navigation[this.currentNavIndex].page_id = (selected.type === 'PAGE') ? selected.id : 0
      this.formData.navigation[this.currentNavIndex].url = selected.url
    }
    // 选择分类时，排斥不在通一一级分类的选项
    // cateCheck() {
    //   var data = this.treeData
    //   const cate_id = this.formData.category_ids[0]
    //   // 未选中，限制解除
    //   if (!cate_id) {
    //     for (let i = 0; i < data.length; i++) {
    //       for (let j = 0; j < data[i].sub_category_list.length; j++) {
    //         data[i].sub_category_list[j].disableCheckbox = false
    //       }
    //     }
    //   } else {
    //     // 选中时，先将全部禁止，再解除选中的一级
    //     for (let i = 0; i < data.length; i++) {
    //       for (let j = 0; j < data[i].sub_category_list.length; j++) {
    //         if (data[i].sub_category_list[j].id === cate_id) {
    //           var par_id_key = i
    //         } else {
    //           data[i].sub_category_list[j].disableCheckbox = true
    //         }
    //       }
    //     }
    //     for (let k = 0; k < data[par_id_key].sub_category_list.length; k++) {
    //       data[par_id_key].sub_category_list[k].disableCheckbox = false
    //     }
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
.form-title {
  background: transparent;
  padding: 24px 0;
  zoom: 1;
  min-height: 48px;
  font-size: 16px;
  color: @heading-color;
  font-weight: 500;
}
.pr {
  position: relative;
}
.flex-box {
  display: flex;
  .flex-box-grow-1 {
    flex-grow: 1;
  }
}
.box {
  // display: flex;
  // min-width: 900px;
  position: relative;
}
.box-left {
  // flex-grow: 1;
  max-width: 800px;
  min-width: 400px;
  margin-right: 400px;
}
.box-right {
  // flex: 0 0 375px;
  // overflow: auto;
  // margin-left: 10%;
  position: absolute;
  right: 0;
  top: 0;
  // top: 50%;
  // transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.2);
  padding: 0 10px 10px;
  z-index: 100
}
.phone-box {
  width: 320px;
  height: 568px;
  background: #fff;
  overflow: hidden;
}
.image-box{
  margin-bottom: 0 !important;
}
</style>
